import { queryKeyFn } from '../../generated/sitContext';
export const timesheetRowsQueryKey = (timesheetId) => queryKeyFn({
    path: '/timesheets/{timesheetId}/rows',
    operationId: 'getApiTimesheetsByUuidRows',
    variables: {
        pathParams: {
            timesheetId,
        },
    },
});
export const timesheetRowQueryKey = (timesheetId, id) => queryKeyFn({
    path: '/timesheets/{timesheetId}/rows/{id}',
    operationId: 'getApiTimesheetRow',
    variables: {
        pathParams: {
            timesheetId,
            id,
        },
    },
});
//# sourceMappingURL=query-key.js.map